export default "skymp5-front/09424635ea350f722acbcde754761c4b.wav";